import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  title: 'General',
  attributeName: 'tagManager',

  fields: [
    {
      attributeName: 'locked',
      helpText: 'Locked of the user',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Locked' ,
      placeholder: 'Locked...',
      hidden:true
    },
    {
      attributeName: 'locked',
      label: 'Locked',
      type: FormInputTypes.LINK,
      icon: IconType.LOCK,
      width: '4rem',
      target:'_self',
      iconSize:'sm',
      iconColor:'#17a2b8',
      helpText: 'Locked Tag.',
      hasClick:false,
      
    }, 
    {
      attributeName: 'application',
      helpText: 'Application of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Aplication',
      placeholder: 'Application...',
      disabled:true
    },
    {
      attributeName: 'type',
      helpText: 'Type of tag',
      type: FormInputTypes.SELECT,
      label: 'Type',
      placeholder: 'Please enter to select a tag type',
      options: [
        { name: 'Content', value: 'content' },
        { name: 'Room', value: 'room' },
      ],
      disabled:true
    },
    {
      attributeName: 'typeTagAssignment',
      helpText: 'Assignment of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Assignment',
      placeholder: 'Assignment...',
      disabled:true
    },
    {
      attributeName: 'typeTagName',
      helpText: 'Category of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Category',
      placeholder: 'Category...',
      disabled:true
    },
    {
      attributeName: 'name',
      helpText: 'Name of the user',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Name...',
      disabled:true,
      visibleWhen: [
        { field: 'application', notValue: '(Empty)' },
      ],
    },
    {
      attributeName: 'description',
      helpText: 'Description of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Description',
      placeholder: 'Description...',
      enabledWhen:{"field":"locked","values":[0]}
    },
    {
      attributeName: 'score',
      helpText: 'Score of the tag',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Score',
      placeholder: 'Score...',
      enabledWhen:{"field":"locked","values":[0]}
    },
    {
      attributeName: 'visible',
      helpText: 'This checkbox is for the main display of the tag. If it is set to false, it will not appear on any representation',
      type: FormInputTypes.CHECKBOX,
      label: 'Visible',
      enabledWhen:{"field":"locked","values":[0]},

    },

  ],
};
